import { Component, Input } from "@angular/core";
import { Update } from "../models/update";

@Component({
  selector: "updates-data-item-v2",
  templateUrl: "./updates-data-item-v2.component.html",
  styleUrls: ["./updates-data-item-v2.component.scss"]
})
export class UpdatesDataItemV2Component {

  @Input() update: Update;

}
